function weLoginPromptMarkSeen()
{
    try
    {
        localStorage.setItem('weLoginPromptSeenAt', String(Date.now()));
    }
    catch (_)
    {
    }
}

function weLoginPromptSeenWithin12h()
{
    try
    {
        var last = localStorage.getItem('weLoginPromptSeenAt');
        if (!last)
        {
            return false;
        }

        var lastNum = parseInt(last, 10);
        if (!isFinite(lastNum))
        {
            return false;
        }

        var twelveHours = 12 * 60 * 60 * 1000;
        return (Date.now() - lastNum) < twelveHours;
    }
    catch (_)
    {
        return false;
    }
}

function weLoginPromptHasLoggedInBefore()
{
    try
    {
        return localStorage.getItem('weHasLoggedInBefore') === 'true';
    }
    catch (_)
    {
        return false;
    }
}

function weLoginPromptSetHasLoggedInBefore()
{
    try
    {
        localStorage.setItem('weHasLoggedInBefore', 'true');
    }
    catch (_)
    {
    }
}

function bindLoginPromptCloseAndLogin()
{
    var backdrop = document.querySelector('[data-we-login-backdrop]');
    if (!backdrop)
    {
        return;
    }

    var btnClose = document.querySelector('[data-we-login-close]');
    if (btnClose)
    {
        btnClose.addEventListener('click', function()
        {
            backdrop.setAttribute('aria-hidden', 'true');
            backdrop.style.display = 'none';
            weLoginPromptMarkSeen();
        });
    }

    var btnLogin = document.querySelector('.we-login-btn');
    if (btnLogin)
    {
        btnLogin.addEventListener('click', function()
        {
            weLoginPromptMarkSeen();
            backdrop.setAttribute('aria-hidden', 'true');
            backdrop.style.display = 'none';
        });
    }
}

function showLoginPromptIfEligible()
{
    var backdrop = document.querySelector('[data-we-login-backdrop]');
    if (!backdrop)
    {
        return;
    }

    var loggedIn = !!window.__weCustomerLoggedIn;

    if (
        loggedIn ||
        !weLoginPromptHasLoggedInBefore() ||
        weLoginPromptSeenWithin12h()
    )
    {
        backdrop.setAttribute('aria-hidden', 'true');
        backdrop.style.display = 'none';
        return;
    }

    backdrop.setAttribute('aria-hidden', 'false');
    backdrop.style.display = 'flex';

    bindLoginPromptCloseAndLogin();
}

document.addEventListener('DOMContentLoaded', function()
{
    //showLoginPromptIfEligible();

    if (window.__weCustomerLoggedIn)
    {
        weLoginPromptSetHasLoggedInBefore();
    }

    document.addEventListener('click', function(e)
    {
        if (e.target.closest('.welleasy-sign-in-btn'))
        {
            weLoginPromptSetHasLoggedInBefore();
        }
    });
});
